import { createReducer, PayloadAction } from "@reduxjs/toolkit";
import { ActionTypes, IState } from "./types";

const INITIAL_STATE: IState = {
  loading: true,
  error: false,
  anoLetivo: new Date().getFullYear(),
};

export const reducers = createReducer(INITIAL_STATE, {
  [ActionTypes.REQUEST]: (state, action: PayloadAction<number>) => ({
    loading: true,
    error: false,
    anoLetivo: action.payload,
  }),
  [ActionTypes.SUCCESS]: (state) => ({
    loading: false,
    error: false,
    anoLetivo: state.anoLetivo,
  }),
  [ActionTypes.FAILURE]: (state) => ({
    loading: false,
    error: true,
    anoLetivo: state.anoLetivo,
  }),
  [ActionTypes.CLEAN]: (state) => ({
    loading: true,
    error: false,
    anoLetivo: state.anoLetivo,
  }),
});
